// dev url
export const URLKpostLogin = 'https://devapi2.kpostindia.com/v2'

export const LocalURL= `http://192.168.0.51:2503/api/v1`

// export const LoginURL = `http://192.168.0.51:2536/api/v1` // Meera Local Dashboard URL

export const LoginURL = `https://api.kadjournal.com/api/v1`

// export const LoginURL = `https://rouge-raleigh-random-florida.trycloudflare.com/api/v1`